<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click="handleCreate"
        >
          增加
        </el-button>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          border
          fit
          highlight-current-row
        >
          <el-table-column align="center" label="ID" width="95">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label="名字" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户名" align="center">
            <template slot-scope="scope">
              {{ scope.row.username }}
            </template>
          </el-table-column>

          <el-table-column
            class-name="status-col"
            label="操作"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn--danger"
                @click="handleDelete(scope.row, list, scope.$index)"
              >删除
              </el-button>
              <el-button
                type="text"
                @click="handleUpdate(scope.row)"
              >修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="total,prev, pager, next,jumper"
        >
        </el-pagination>
      </div>

      <!-- 弹窗 - 添加用户 -->
      <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" title="添加用户">
        <el-form
          ref="dataForm"
          :model="orderList"
          label-position="left"
          label-width="100px"
          :rules="rules"
          style="margin-left: 50px"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="orderList.name"/>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="orderList.username"/>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="orderList.password" show-password/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="createSumbit">提交</el-button>
        </div>
      </el-dialog>

      <!-- 弹窗 - 修改用户 -->
      <el-dialog :visible.sync="dialogFormUpdate" title="修改用户">
        <el-form
          ref="updateList"
          :model="updateList"
          label-position="left"
          label-width="100px"
          :rules="rules"
          style="margin-left: 50px"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="updateList.name"/>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model="updateList.username"/>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="updateList.password" show-password/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel()">取消</el-button>
          <el-button type="primary" @click="updateSumbit">修改</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    filters: {
      /**
       * 状态过滤器
       * @param {string} status - 状态值
       * @returns {string} 对应的Element UI类型
       */
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger'
        }
        return statusMap[status]
      }
    },
    data() {
      return {
        // 列表数据
        list: [],
        // 修改表单数据
        updateList: [],
        // 列表加载状态
        listLoading: true,
        // 添加弹窗显示状态
        dialogFormVisible: false,
        // 修改弹窗显示状态
        dialogFormUpdate: false,
        // 弹窗标题映射
        textMap: {
          update: 'Edit',
          create: '添加采购信息'
        },
        // 添加表单数据
        orderList: {},
        // 总条目数
        aSum: 0,
        // 当前页数
        currentPage: 1,
        // 总页数
        pageCount: 1,
        // 每页显示条目数
        pagesize: 10,
        // 表单验证规则
        rules: {
          name: [{required: true, message: '请填写该字段', trigger: 'blur'}],
          username: [
            {required: true, message: '请填写该字段', trigger: 'blur'},
            {min: 3, message: '最少3个字', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请填写该字段', trigger: 'blur'},
            {min: 4, message: '最少4个字符', trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {
    },

    created() {
      // 初始化时获取管理员列表
      this.fetchData()
    },

    methods: {
      /**
       * 获取管理员列表数据
       */
      fetchData() {
        this.listLoading = true
        let url = this.baseUrl + "/admin/admin_users/";
        api.fetchData(url).then((response) => {
          this.list = response.results
          this.listLoading = false
          this.aSum = response.count
          this.currentPage = 1
        })
      },

      /**
       * 分页切换处理
       * @param {number} val - 目标页码
       */
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/admin_users/?page" + val;
        api.fetchData(url).then((response) => {
          this.list = response.results
          this.listLoading = false
          this.aSum = response.data.count
          this.currentPage = val
        })
      },

      /**
       * 打开添加用户弹窗
       */
      handleCreate() {
        this.dialogFormVisible = true
      },

      /**
       * 打开修改用户弹窗
       * @param {object} row - 当前行数据
       */
      handleUpdate(row) {
        this.dialogFormUpdate = true
        this.updateList = row
      },

      /**
       * 删除管理员账号
       * @param {object} row - 当前行数据
       * @param {Array} list - 列表数据引用
       * @param {number} index - 当前行索引
       */
      handleDelete(row, list, index) {
        this.$confirm('此操作将永久删除该管理员账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let url = this.baseUrl + "/admin/admin_users/" + row.id + '/';
            api.deleteData(url).then((response) => {
              list.splice(index, 1)
              this.$message({
                message: '删除成功',
                type: 'success'
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '删除失败'
              })
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },

      /**
       * 提交新增管理员表单
       */
      createSumbit() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let url = this.baseUrl + "/admin/admin_users/";
            api.postData(url, this.orderList).then((response) => {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.dialogFormVisible = false
              this.fetchData()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '添加失败'
              })
            })
          }
        })
      },

      /**
       * 提交修改管理员表单
       */
      updateSumbit() {
        this.$refs['updateList'].validate((valid) => {
          if (valid) {
            let url = this.baseUrl + "/admin/admin_users/" + this.updateList.id + '/';
            api.patchData(url, this.updateList).then((response) => {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogFormUpdate = false
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '修改失败'
              })
            })
          } else {
            return false
          }
        })
      },

      /**
       * 取消修改，关闭弹窗
       */
      cancel() {
        this.dialogFormUpdate = false
      }
    }
  }
</script>
<style scoped>
  .filter-container {
    padding-bottom: 10px;
  }

  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/account.vue